let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7mXtG")).then(() => parcelRequire('aECgo'));